import { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";

// Reuse the existing API URL env var (strip trailing slash if present)
const HUB_URL = `${(process.env.REACT_APP_API_URL || "").replace(/\/$/, "")}/hubs/position-status`;

/**
 * Connects to the position-status SignalR hub and returns the latest snapshot.
 *
 * The server broadcasts the full current snapshot as a "PositionStatusUpdate" event
 * on connect and whenever MQTT delivers a new position message.
 *
 * @returns {{ [requestId: string]: { isInside: boolean, timestamp: number, authorizationRequiredFrom: string | null } }}
 */
export function usePositionStatus() {
  const [snapshot, setSnapshot] = useState({});

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, {
        // App uses cookie-based auth — credentials are sent automatically
        withCredentials: true,
        // Simulate WebSockets blocked → force fallback to SSE then Long Polling
        // transport: signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Warning)
      .build();

    connection.on("PositionStatusUpdate", (data) => {
      setSnapshot(data ?? {});
    });

    connection.start().catch((err) => {
      console.error("[usePositionStatus] Failed to connect:", err);
    });

    return () => {
      connection.stop();
    };
  }, []);

  return snapshot;
}
